import cardio from '../elements/cardio.js';
cardio.register();
